module.exports = __webpack_public_path__ + "static/media/zlobek_movie.2471a314.mp4";